import _ from 'underscore';

const MAX_DAYS = 7;

// timestamp: Date
export function getTimeDescription(timestamp, i18n) {
  if (_.isDate(timestamp)) {
    const now = new Date();

    const diffInSec = Math.round((now - timestamp) / 1000);
    if (diffInSec < 0) {
      // in case something is wrong
      return null;
    } else if (diffInSec === 0) {
      return i18n.getString(_TL_('just now'));
    } else if (diffInSec === 1) {
      return i18n.getString(_TL_('1 second ago'));
    } else if (diffInSec < 60) {
      return i18n.getString(_TL_('{{seconds}} seconds ago'), { seconds: diffInSec });
    }

    const diffInMin = Math.round(diffInSec / 60);
    if (diffInMin === 1) {
      return i18n.getString(_TL_('1 minute ago'));
    } else if (diffInMin < 60) {
      return i18n.getString(_TL_('{{minutes}} minutes ago'), { minutes: diffInMin });
    }

    const diffInHour = Math.round(diffInMin / 60);
    if (diffInHour === 1) {
      return i18n.getString(_TL_('1 hour ago'));
    } else if (diffInHour < 24) {
      return i18n.getString(_TL_('{{hours}} hours ago'), { hours: diffInHour });
    }

    const diffInDay = Math.round(diffInHour / 24);
    if (diffInDay === 1) {
      return i18n.getString(_TL_('1 day ago'));
    } else if (diffInDay <= MAX_DAYS) {
      return i18n.getString(_TL_('{{days}} days ago'), { days: diffInDay });
    }
  }

  // no description for timestamp > 30 days ago
  return null;
}
